module.exports = __webpack_public_path__ + "static/media/ford-transit-right.eab3c2de.png";